import React, { ChangeEvent, FocusEvent } from 'react';
import { UseFormClearErrors } from 'react-hook-form';
import { CommonCheckInputProps } from '../../../types/common';

export const CheckboxTestId = 'checkbox-input';
export type CheckboxProps = CommonCheckInputProps & {
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  clearErrors?: (fieldName?: string) => void | UseFormClearErrors<{
    customFields: { [key: string]: unknown };
  }>;
};

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  hasErrors,
  className = '',
  defaultChecked,
  register,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyDown,
  clearErrors,
}: CheckboxProps) => {
  const classes = `${className} form-checkbox ml-2 h-4 w-4 ${
    hasErrors ? 'input-error-border' : ''
  }`;

  if (!register) {
    return (
      <input
        type="checkbox"
        id={name}
        name={name}
        className={classes}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onClick={onClick}
        data-testid={CheckboxTestId}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
    );
  }

  const {
    onChange: rhfOnChange,
    onBlur: rhfOnBlur,
    ...rest
  } = register?.(name) ?? {};

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
    rhfOnChange?.(event);
    onChange?.(event);
    clearErrors?.(name);
  };

  const handleOnBlur = (event: FocusEvent<HTMLInputElement>): void => {
    rhfOnBlur?.(event);
    onBlur?.(event);
  };

  return (
    <input
      name={name}
      type="checkbox"
      id={name}
      className={classes}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onClick={onClick}
      data-testid={CheckboxTestId}
      defaultChecked={defaultChecked}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};

export default Checkbox;
